var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ParentPortal',{attrs:{"tabs":_vm.sidePanelComponents}},[(_vm.reference)?_c('router-view',{staticClass:"main-content",attrs:{"reference":_vm.reference}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }